import { Description } from '../../../description/shared/classes/description';
import { Adresse } from './adresse';
import { Email } from './email';
import { Telephone } from './telephone';
import { RoleRecherche } from './role-recherche';
import { formatDate } from '@angular/common';
import {Civilite} from "./civilite";

export class Identite implements Object {

    id: string;
    ref_metier: string;
    adresses_id: string;
    allow_connexion: string;
    allow_ip: string;
    login: string;
    password: string;
    civilites_id: string;
    nom: string;
    prenom: string;
    computed_name: string;
    couleur: string;
    ctp_id: string;
    adresse: Adresse;
    emails: any;
    telephones: any;
    date_entree: string;
    etat_identite_id: string;
    recherches: RoleRecherche[];
    roles_id_commercial: string;
    descriptions: Description[];
    date_update: string;
    prv_id: string;
    mct_id: string;
    siret: string;
    code_tva_intra: string;
    capital_montant: string;
    civilite: Civilite;
    role: any;
    acl_roles_id: any;
    cop_nom: string;

    roles_id_commercial_secondaire: any = 0;
    roles_id_commercial_tertiaire: any = 0;
    interne: string;
    pied_page: string;

    relations: {[field: string]: Array<Identite | any>};
    lieu_naissance: string;
    date_naissance: Date;
    matricule: string;
    iban: string;
    etat_civil: string;
    profession: string;
    nb_enfants: string;

    change_password: any;
    condition_paiement: string;

    numero_ibs: string; // Spécifique GIO...
    personnes_contact: any;
    num_ipi: string;

    language: string;
    identites_id: string;
    prefixe_facture: string;
    numero_entreprise: string;
    assujetti_tva: number;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id             = data['id'] ? data['id'] : data.identites_id ? data.identites_id : null;
        this.ref_metier     = data['ref_metier'] ? data['ref_metier'] : null;
        this.adresses_id    = data['adresses_id'] ? data['adresses_id'] : null;
        this.allow_connexion = data['allow_connexion'] ? data['allow_connexion'] : '';
        this.allow_ip       = data['allow_ip'] ? data['allow_ip'] : null;
        this.login          = data['login'] ? data['login'] : null;
        this.password       = data['password'] ? data['password'] : null;
        this.civilites_id   = data['civilites_id'] ? data['civilites_id'] : null;
        this.nom            = data['nom'] ? data['nom'] : null;
        this.prenom         = data['prenom'] ? data['prenom'] : null;
        this.computed_name  = data['computed_name'] ? data['computed_name'] : null;
        this.ctp_id         = data['ctp_id'] ? data['ctp_id'] : null;
        this.prv_id         = data['prv_id'] ? data['prv_id'] : null;
        this.mct_id         = data['mct_id'] ? data['mct_id'] : null;
        this.siret          = data['siret'] ? data['siret'] : null;
        this.code_tva_intra = data['code_tva_intra'] ? data['code_tva_intra'] : null;
        this.capital_montant = data['capital_montant'] ? data['capital_montant'] : null;
        this.civilite       = data['civilite'] ? new Civilite(data['civilite']) : new Civilite();
        this.couleur        = data['couleur'] ? data['couleur'] : null;
        this.date_update    = data['date_update'] ? data['date_update'] : null;
        this.roles_id_commercial = data['roles_id_commercial'] ? data['roles_id_commercial'] : null;
        this.etat_identite_id = data['etat_identite_id'] ? data['etat_identite_id'] : null;
        this.date_entree    = data['date_entree'] ? data['date_entree'] : formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        this.adresse        = data['adresse'] ? new Adresse(data['adresse']) : new Adresse();
        this.emails         = {personnel: new Email('personnel'), professionnel: new Email('professionnel')};
        this.role           = data['role'] ? data['role'] : null;
        this.acl_roles_id    = data['acl_roles_id'] ? data['acl_roles_id'] : null;
        this.cop_nom        = data['cop_nom'] ? data['cop_nom'] : null;

        this.roles_id_commercial_secondaire = data['roles_id_commercial_secondaire'] ? data['roles_id_commercial_secondaire'] : 0;
        this.roles_id_commercial_tertiaire = data['roles_id_commercial_tertiaire'] ? data['roles_id_commercial_tertiaire'] : 0;

        if (data['emails'] && data['emails']['personnel']) {
            this.emails.personnel = new Email('personnel', data['emails']['personnel']);
        }
        if (data['emails'] && data['emails']['professionnel']) {
            this.emails.professionnel = new Email('professionnel', data['emails']['professionnel']);
        }

        this.telephones         = {domicile: new Telephone('domicile'), mobile: new Telephone('mobile')};
        if (data['telephones'] && data['telephones']['domicile']) {
            this.telephones.domicile = new Telephone('domicile', data['telephones']['domicile']);
        } else {
            this.telephones.domicile = new Telephone('domicile');
        }
        if (data['telephones'] && data['telephones']['mobile']) {
            this.telephones.mobile = new Telephone('mobile', data['telephones']['mobile']);
        } else {
            this.telephones.mobile = new Telephone('mobile');
        }
        if (data['telephones'] && data['telephones']['bureau']) {
            this.telephones.bureau = new Telephone('bureau', data['telephones']['bureau']);
        } else {
            this.telephones.bureau = new Telephone('bureau');
        }

        this.recherches     = data['recherches'] ? data['recherches'] : null;
        this.descriptions   = data['description'] ? data['description'] : [];
        this.interne        = data['interne'] ? data['interne'] : '0';
        this.pied_page      = data['pied_page'] ? data['pied_page'] : '';
        this.condition_paiement = data['condition_paiement'] ? data['condition_paiement'] : '';

        this.date_naissance = data['date_naissance'];
        this.lieu_naissance = data['lieu_naissance'];
        this.matricule = data['matricule'];
        this.iban = data['iban'];
        this.etat_civil = data['etat_civil'];
        this.profession = data['profession'];
        this.nb_enfants = data['nb_enfants'];
        this.relations = data['relations'] || {};

        this.numero_ibs = data['numero_ibs'] ? data['numero_ibs'] : null;
        this.personnes_contact = data['personnes_contact'] ? data['personnes_contact'] : null;
        this.language = data['language'] ? data['language'] : 'FR';
        this.num_ipi = data['num_ipi'] ? data['num_ipi'] : null;
        this.identites_id = data['identites_id'] ? data['identites_id'] : null;
        this.prefixe_facture = data['prefixe_facture'] ? data['prefixe_facture'] : null;
        this.numero_entreprise = data['numero_entreprise'] ? data['numero_entreprise'] : null;
        this.assujetti_tva = data['assujetti_tva'] ? data['assujetti_tva'] : 0;
    }


    public getEmail(type?: string) {
        if (!type) {
            type = 'personnel';
        }

        const email = this.emails[type] ? this.emails[type]['libelle'] : (this.emails['professionnel'] ? this.emails['professionnel']['libelle'] : '');

        return email;
    }

    public getGsm() {
        const gsm = this.telephones['mobile'] ? this.telephones['mobile']['libelle'] : '';

        return gsm;
    }

    public getEmails() {
        let emails = '';

        emails += this.getEmail('personnel');
        emails += this.getEmail('profesionnel');


        return emails;
    }

}
